module.exports = __webpack_public_path__ + "static/media/bargain-banner.8eb1be5f.png";